import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ParticipantCounter from './ParticipantCounter';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAdults, setChildrenAge } from '../../actions/formActions';
import './style.scss';
import BoxChildAge from './BoxChildAge';
import {
    ADULTS_MAX,
    ADULTS_MIN,
    CHILDREN_DEFAULT,
    CHILDREN_MAX,
    CHILDREN_MAX_AGE,
    CHILDREN_MIN,
    CHILDREN_MIN_AGE
} from '../../consts/data'

const Participants = ({
    adults,
    children,
    setAdults,
    setChildrenAge,
    onValidityChange
}) => {
    const { t } = useTranslation();
    const [childrenCounter, setChildrenCounter] = useState(0);
    const [ages, setAges] = useState([]);

    useEffect(() => {
        setChildrenCounter(children.length);
        setAges(children);
    }, [children]);

    useEffect(() => {
        if (childrenCounter > ages.length) {
            const extended = [...ages, ...Array(childrenCounter - ages.length).fill('')];
            setAges(extended);
            setChildrenAge(extended);
        } else if (childrenCounter < ages.length) {
            const reduced = ages.slice(0, childrenCounter);
            setAges(reduced);
            setChildrenAge(reduced);
        }
    }, [childrenCounter]);

    useEffect(() => {
        const isValid = ages.length === childrenCounter &&
            ages.every(
                age => typeof age === 'number' &&
                age >= CHILDREN_MIN_AGE && age <= CHILDREN_MAX_AGE
            )

        if (typeof onValidityChange === 'function') {
            onValidityChange(isValid)
        }
    }, [ages, childrenCounter])

    const ageChangeHandler = (index, value) => {
        let age = parseInt(value, 10);

        if (isNaN(age)) age = '';
        if (age < CHILDREN_MIN_AGE) age = CHILDREN_MIN_AGE;
        if (age > CHILDREN_MAX_AGE) age = CHILDREN_MAX_AGE;

        const newAges = [...ages];
        newAges[index] = age;

        setAges(newAges);
        setChildrenAge(newAges);
    };

    return (
        <>
            <div className="trip-modal__columns">
                <ParticipantCounter
                    label={t('modal.participants.count_adults')}
                    value={adults}
                    onChange={setAdults}
                    min={ADULTS_MIN}
                    max={ADULTS_MAX}
                />
            </div>
            <div className="trip-modal__columns">
                <ParticipantCounter
                    label={t('modal.participants.count_children')}
                    value={childrenCounter}
                    onChange={setChildrenCounter}
                    min={CHILDREN_MIN}
                    max={CHILDREN_MAX}
                />
            </div>
            {childrenCounter > 0 && (
                <div className="trip-modal__columns trip-modal__columns--3">
                    {ages.map((age, index) => {
                        const label = t('modal.participants.age_of_child')
                            .replace(':nr', (index + 1))

                        return (
                            <BoxChildAge
                                key={`box-age-${index}`}
                                index={index + 1}
                                label={label}
                                age={age}
                                onChange={(val) => ageChangeHandler(index, val)}
                                min={CHILDREN_MIN_AGE}
                                max={CHILDREN_MAX_AGE}
                            />
                        )}
                    )}
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    adults: state.formReducer.dorosli,
    children: state.formReducer.dzieci
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setAdults,
            setChildrenAge
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Participants);
